module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-31.a9e0fa0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-31.jpg
// module id = 3987
// module chunks = 13